import { Header } from "@/components/header"
import { Hero } from "@/components/hero"
import { Expertise } from "@/components/expertise"
import { Experience } from "@/components/experience"
import { CaseStudies } from "@/components/case-studies"
import { Insights } from "@/components/insights"
import { Contact } from "@/components/contact"
import { Footer } from "@/components/footer"

export default function App() {
    return (
        <main className="min-h-screen bg-background text-foreground">
            <Header />
            <Hero />
            <Expertise />
            <Experience />
            <CaseStudies />
            <Insights />
            <Contact />
            <Footer />
        </main>
    )
}
